import { Modal } from "@common/Modal/Modal";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IError } from "itsf-ui-common";
import { useDeviceType } from "@hook/useDeviceType";
import { ReactElement, ReactNode } from "react";
import { useStyle } from "@common/ConfirmationModal/style";

interface IParams {
    title: string;
    subtitle?: ReactNode;
    children?: ReactNode;
    error?: IError;
    isLoading: boolean;
    isModalOpen: boolean;
    onContinue(): void;
    onClose(): void;
    continueLabel?: string;
    cancelLabel?: string;
    hideCancel?: boolean;
    closeIcon?: ReactElement<{ onClick: () => void }>;
    topOffset?: number;
}

export const ConfirmationModal = (props: IParams) => {
    const {
        title,
        subtitle,
        children,
        error,
        isLoading,
        isModalOpen,
        onContinue,
        onClose,
        continueLabel,
        cancelLabel,
        hideCancel,
        closeIcon,
        topOffset,
    } = props;
    const { t } = useTranslation("common");
    const { isMobile } = useDeviceType();
    const { classes } = useStyle({ isMobile });

    return (
        <Modal
            close={onClose}
            closeIcon={closeIcon}
            hideActions
            isModalOpen={isModalOpen}
            subTitle={subtitle}
            title={title}
            topOffset={topOffset}
        >
            <HandleErrorAndLoading error={error} hideComponentWrapper isLoading={isLoading}>
                {children}
            </HandleErrorAndLoading>
            <Stack className={classes.buttonStack}>
                <Button
                    disabled={isLoading ?? error}
                    fullWidth={isMobile}
                    size="large"
                    variant="contained"
                    onClick={onContinue}
                >
                    {continueLabel ?? t("continue")}
                </Button>
                {!hideCancel && (
                    <Button fullWidth={isMobile} size="large" variant="text" onClick={onClose}>
                        {cancelLabel ?? t("cancel")}
                    </Button>
                )}
            </Stack>
        </Modal>
    );
};
